export default "__VITE_ASSET__BAKgiLNR__"